module.exports = __webpack_public_path__ + "static/media/menuIcon.2983abbd.svg";